"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerMoveCommand = void 0;
const actions_1 = require("../../actions");
const move_current_to_column_action_1 = require("../../actions/move-current-to-column-action");
const move_next_to_current_action_1 = require("../../actions/move-next-to-current-action");
const card_1 = require("../../card");
const logic_types_1 = require("../../logic-types");
const auto_clear_column_command_1 = require("../auto-commands/auto-clear-column-command");
const player_command_1 = require("./player-command");
class PlayerMoveCommand {
    static isCommand(command) {
        return command instanceof PlayerMoveCommand;
    }
    constructor(columnId) {
        this.columnId = columnId;
    }
    serializeToString() {
        return `${player_command_1.CommandTypes.Move} ${card_1.PileIdHandler.getStringFromPileId(this.columnId)}`;
    }
    validateCommand(context, existingDeal) {
        if (context.gameState.getRoundState() !== logic_types_1.RoundState.Play &&
            !existingDeal) {
            return false;
        }
        return true;
    }
    executeCommand(commandHash, instant, context) {
        return __awaiter(this, void 0, void 0, function* () {
            context.gameState.setRoundState(logic_types_1.RoundState.Transition, instant);
            context.eventQueue.enqueue({
                type: "onBeforeMoveToColumn",
                instant,
                payload: {
                    columnId: this.columnId,
                    cardColumns: context.entitiesManager.allColumnsClone(),
                },
            });
            this.moveCurrentToColumn(instant, context);
            this.moveNextToCurrent(instant, context);
            yield this.checkScoring(instant, context);
            context.eventQueue.enqueue({
                type: "onShowHint",
                instant,
                payload: {
                    cardStackCurrent: context.entitiesManager.cardStackCurrent.clone(),
                    cardColumns: context.entitiesManager.allColumnsClone(),
                },
            });
            context.gameState.setRoundState(logic_types_1.RoundState.Play, instant);
            yield this.drawDeck(commandHash, instant, context);
            context.eventQueue.enqueue({
                type: "onRemainingCardsChanged",
                instant,
                payload: {
                    remainingCards: context.entitiesManager.remainingCards,
                },
            });
            if (context.entitiesManager.isGameCompleted) {
                context.gameState.setRoundState(logic_types_1.RoundState.Finish, false);
                context.eventQueue.enqueue({
                    type: "onGameCompleted",
                    instant: false,
                    payload: undefined,
                });
                return;
            }
            context.eventQueue.enqueue({
                type: "onAfterMoveToColumn",
                instant,
                payload: {
                    cardStackCurrent: context.entitiesManager.cardStackCurrent.clone(),
                    cardColumns: context.entitiesManager.allColumnsClone(),
                },
            });
        });
    }
    moveCurrentToColumn(instant, context) {
        var _a;
        const action = new move_current_to_column_action_1.MoveCurrentToColumnAction(context.entitiesManager.board, this.columnId);
        action.execute();
        action.resolve();
        if ((_a = action.cardId) === null || _a === void 0 ? void 0 : _a.isWild) {
            context.analyticsData.totalWildCardsUsed++;
        }
        context.analyticsData.totalCardsUsed++;
        context.eventQueue.enqueue({
            type: "onMoveCurrentToColumn",
            instant,
            payload: {
                cardColumn: context.entitiesManager.cardColumn(this.columnId).clone(),
                cardIndex: action.cardIndex,
            },
        });
    }
    moveNextToCurrent(instant, context) {
        const action = new move_next_to_current_action_1.MoveNextToCurrentAction(context.entitiesManager.board);
        if (action.validate()) {
            action.execute();
            action.resolve();
            context.eventQueue.enqueue({
                type: "onMoveNextToCurrent",
                instant,
                payload: {
                    cardStackNext: context.entitiesManager.cardStackNext.clone(),
                    cardStackCurrent: context.entitiesManager.cardStackCurrent.clone(),
                    cardIndex: action.cardIndex,
                },
            });
        }
    }
    checkScoring(instant, context) {
        return __awaiter(this, void 0, void 0, function* () {
            const cardColumn = context.entitiesManager.cardColumn(this.columnId);
            // Always send a stack result
            context.gameState.sendPlayerActionResult(cardColumn, logic_types_1.PlayerActionResult.Stack, instant);
            if (cardColumn.containsWild) {
                context.gameState.sendPlayerActionResult(cardColumn, logic_types_1.PlayerActionResult.Wild, instant);
                yield this.clearColumn(this.columnId, instant, context);
            }
            else if (cardColumn.isBust) {
                context.gameState.sendPlayerActionResult(cardColumn, logic_types_1.PlayerActionResult.Bust, instant);
                yield this.clearColumn(this.columnId, instant, context);
            }
            else if (cardColumn.hasReachedTargetScore) {
                context.gameState.sendPlayerActionResult(cardColumn, logic_types_1.PlayerActionResult.ReachedTarget, instant);
                yield this.clearColumn(this.columnId, instant, context);
            }
        });
    }
    drawDeck(commandHash, instant, context) {
        return __awaiter(this, void 0, void 0, function* () {
            const action = new actions_1.DrawDeckToNextAction(context.entitiesManager.board);
            if (action.validate()) {
                action.execute();
                yield context.dealProcessor.disclosePendingCards(commandHash);
                action.resolve();
                context.eventQueue.enqueue({
                    type: "onDrawDeckToNext",
                    instant,
                    payload: {
                        cardStackNext: context.entitiesManager.cardStackNext.clone(),
                        cardIndex: action.cardIndex,
                    },
                });
            }
        });
    }
    clearColumn(columnId, instant, context) {
        return __awaiter(this, void 0, void 0, function* () {
            const autoClearColumnCommand = new auto_clear_column_command_1.AutoClearColumnCommand(columnId, context.entitiesManager, context.eventQueue);
            yield autoClearColumnCommand.executeCommand("", instant);
        });
    }
}
exports.PlayerMoveCommand = PlayerMoveCommand;
